import { render, staticRenderFns } from "./setCriteria.vue?vue&type=template&id=25ed082e&scoped=true&"
import script from "./setCriteria.vue?vue&type=script&lang=js&"
export * from "./setCriteria.vue?vue&type=script&lang=js&"
import style0 from "./setCriteria.vue?vue&type=style&index=0&id=25ed082e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ed082e",
  null
  
)

export default component.exports